import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import PersonnelFlow from "@/pages/PersonnelFlow";
import PersonnelLogin from "@/pages/PersonnelLogin";
import MyTickets from "@/pages/MyTickets";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/components/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminTickets from "@/pages/AdminTickets";
import AdminUsers from "@/pages/AdminUsers";
import { AdminProvider } from "@/lib/adminContext";
import { PersonnelProvider } from "@/lib/personnelContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminProvider>
          <PersonnelProvider>
            <Routes>
              <Route path="/" element={<PersonnelFlow />} />
              <Route path="/login" element={<PersonnelLogin />} />
              <Route path="/my-tickets" element={<MyTickets />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="tickets" element={<AdminTickets />} />
                <Route path="users" element={<AdminUsers />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </PersonnelProvider>
        </AdminProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
